module.exports = __webpack_public_path__ + "img/logo.e86a8aea.png";